import { BankCode, CardPaymentMerchantEnum } from '@libs/backend-common';
import {
  tbcBankIcon,
  bogIcon,
  credoBankIcon,
  isBankIcon,
  pashaBankIcon,
  halykBankIcon,
  teraBankIcon,
  silkBankIcon,
  procreditBankIcon,
  ziraatBankIcon,
  cartuBankIcon,
  basisBankIcon,
  libertyBankIcon,
  ZenIcon,
} from '../assets';

export const BOG_REFERENCE_CODE = '26127159';

export const BANK_ICONS = {
  [BankCode.TBCBGE22]: tbcBankIcon,
  [BankCode.BAGAGE22]: bogIcon,
  [BankCode.JSCRGE22]: credoBankIcon,
  [BankCode.ISBKGE22]: isBankIcon,
  [BankCode.PAHAGE22]: pashaBankIcon,
  [BankCode.HABGGE22]: halykBankIcon,
  [BankCode.TEBAGE22]: teraBankIcon,
  [BankCode.DISNGE22]: silkBankIcon,
  [BankCode.MIBGGE22]: procreditBankIcon,
  [BankCode.TCZBGE22]: ziraatBankIcon,
  [BankCode.CRTUGE22]: cartuBankIcon,
  [BankCode.CBASGE22]: basisBankIcon,
  [BankCode.LBRTGE22]: libertyBankIcon,
  [BankCode.BZENLT22]: ZenIcon,
};

export const BANK_LABELS = {
  [BankCode.TBCBGE22]: 'bank_tbc',
  [BankCode.BAGAGE22]: 'bank_bog',
  [BankCode.JSCRGE22]: 'bank_credo',
  [BankCode.ISBKGE22]: 'bank_isbank',
  [BankCode.PAHAGE22]: 'bank_pasha',
  [BankCode.HABGGE22]: 'bank_halyk',
  [BankCode.TEBAGE22]: 'bank_tera',
  [BankCode.DISNGE22]: 'bank_silk',
  [BankCode.MIBGGE22]: 'bank_proCredit',
  [BankCode.TCZBGE22]: 'bank_ziraat',
  [BankCode.CRTUGE22]: 'bank_cartu',
  [BankCode.CBASGE22]: 'bank_basis',
  [BankCode.LBRTGE22]: 'bank_liberty',
  [BankCode.BZENLT22]: 'bank_zen',
};
export const MERCHANT_BANK_CODES = {
  [CardPaymentMerchantEnum.BOG]: BankCode.BAGAGE22,
  [CardPaymentMerchantEnum.FLITT]: BankCode.TBCBGE22,
};
